import styled from '@emotion/styled/macro';

/* eslint-disable import/prefer-default-export */
export const MatchResultCard = styled.div`
    flex-basis: 49.5%;
    border-radius: ${props => props.theme.spacing.xlarge2};
    background-color: ${props => props.theme.colours.white};
`;
